import {twMerge} from '../../../common/twMerge';
import {BASE_VIEWER_WIDTH_PX} from '../../../domain/content/[seriesId]/viewer/[productId]/constant/talkViewerConstant';
import {useViewerWidth} from '../../../domain/content/[seriesId]/viewer/[productId]/hook/useViewerWidth.hook';
import {TalkPosition} from '../../../domain/content/[seriesId]/viewer/[productId]/type/TalkPosition.enum';
import {ZIndex} from '../../../domain/content/[seriesId]/viewer/[productId]/type/ZIndex.enum';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {TalkReplayBoxProps} from './TalkReplayBoxProps.interface';

export function TalkReplayBox({
  onClickReplayBox,
  talkPosition,
  talkWidth,
  showReplay,
}: TalkReplayBoxProps) {
  const {viewerWidth} = useViewerWidth();
  // 다시보기는 오른쪽 톡 외에는 모두 오른쪽에 뜨는 게 default
  let replayBoxPosition =
    talkPosition === TalkPosition.Right
      ? ReplayBoxPosition.Left
      : ReplayBoxPosition.Right;
  // 톡 길이가 450px(720기준)을 넘어가면 다시보기를 아래에 그려준다
  if (talkWidth >= 450 * (viewerWidth / BASE_VIEWER_WIDTH_PX)) {
    replayBoxPosition = ReplayBoxPosition.Bottom;
  }

  return (
    <div
      className={twMerge(
        !showReplay && 'hidden',
        REPLAY_BOX_COMMON_STYLE,
        REPLAY_BOX_POSITION_STYLE[replayBoxPosition]
      )}
      style={{zIndex: ZIndex.Talk + 1}}
    >
      <Icon
        type={REPLAY_BOX_POSITION_ICON[replayBoxPosition]}
        onClick={onClickReplayBox}
        className="w-full"
      />
    </div>
  );
}

const REPLAY_BOX_COMMON_STYLE = 'absolute pointer-events-auto w-128tvs';

enum ReplayBoxPosition {
  Left = 'left',
  Right = 'right',
  Bottom = 'bottom',
}

const REPLAY_BOX_POSITION_STYLE: {[key in ReplayBoxPosition]: string} = {
  [ReplayBoxPosition.Left]: 'top-1/2 left-0 -translate-x-full -translate-y-1/2',
  [ReplayBoxPosition.Right]:
    'top-1/2 right-0 translate-x-full -translate-y-1/2',
  [ReplayBoxPosition.Bottom]:
    'bottom-0 left-1/2 -translate-x-1/2 translate-y-full',
};

const REPLAY_BOX_POSITION_ICON: {
  [key in ReplayBoxPosition]: IconType;
} = {
  [ReplayBoxPosition.Left]: IconType.BtnReplayLeft,
  [ReplayBoxPosition.Right]: IconType.BtnReplayRight,
  [ReplayBoxPosition.Bottom]: IconType.BtnReplayBottom,
};
